module.exports = {
    "collectionLabel": `Sugest\xf5es`
};


//# sourceMappingURL=pt-PT.main.js.map
